export default [
  { title: "How to Guides", icon: "", link: "/docs/how-to-guides" },
  { title: "Code example launchers", icon: "", link: "/docs/code-example-launcher" },
  { title: "Embed the DocuSign UI in your app", icon: "", link: "/docs/embed-the-docusign" },
];
